/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import CommissionOfferModal from "../../Modals/commissionOffer";

const NotificationsList = () => {

  const rows = [
    {
      id: 1,
      title: "Property Maintenance",
      message: "Our maintenance team will contact you shortly to schedule a visit.",
      type: 'Broadcast',
      sendTo: 'Customers',
      date: '01 March 2025'
    },
    {
      id: 2,
      title: "Property Maintenance",
      message: "Our maintenance team will contact you shortly to schedule a visit.",
      type: 'Email',
      sendTo: 'Maintenance Team',
      date: '01 March 2025'
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "title",
      headerName: "Title",
      editable: false,
      sortable: false,
    },
    {
      flex: 2,
      minWidth: 200,
      field: "message",
      headerName: "Message",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "type",
      headerName: "Type",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "sendTo",
      headerName: "Send To",
      editable: false,
      sortable: false,
    },
    {
      minWidth: 150,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
    },    
    {
      minWidth: 100,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton>
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        )
      }
    }
  ];
  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>

      <CommissionOfferModal open={open} onClose={handleCloseModal} setOpen={setOpen} />
      <RejectReasonModal open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />
    </>
  );
};

export default NotificationsList;
